module.exports = __webpack_public_path__ + "img/600.ec2cadbe.svg";